import React from "react";

import { Outlet } from "react-router-dom";

import "../css/styles.css";


const HomeIndex = () => {

    return (
        <>
            <div className="col-12 d-flex justify-content-center">
                <div className="width-full-page relative-div-bg">
                    <div className="absolute-div-home">
                        <div className="absolute-home-div-img" />
                    </div>
                </div>
            </div>
            <div className="min-height"><Outlet /></div>
        </>
    );
};

export default HomeIndex;
